import { FC } from "react";
import { VStack } from "@design-system/VStack/VStack";
import {
    StandardModalFooter,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import actionsStyles from "../ClientActions.module.scss";
import styles from "./OrgWorkspaceWarningModal.module.scss";

interface Props {
    onClose: () => void;
    onConfirm: () => void;
}

export const OrgWorkspaceWarningModal: FC<Props> = ({ onClose, onConfirm }) => (
    <>
        <StandardModalHeader className={actionsStyles.modalHeader}>
            This is your organization's workspace
        </StandardModalHeader>
        <VStack gap={8} className="mt-2">
            <div>
                This workspace belongs to your organization, not an individual
                client. Entities added here will be part of your organization's
                own books.
            </div>
            <div>Are you sure you want to add an entity here?</div>
        </VStack>
        <StandardModalFooter className={styles.footer}>
            <Button
                type="button"
                variant="secondary"
                onClick={onClose}
                size="xl"
            >
                Cancel
            </Button>
            <Button
                type="button"
                variant="primary"
                onClick={onConfirm}
                size="xl"
            >
                Add entity
            </Button>
        </StandardModalFooter>
    </>
);
